import React, { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faUser } from "@fortawesome/free-solid-svg-icons";
import emailjs from "@emailjs/browser";
import { motion } from "motion/react";
import ContactMessages from "./ContactMessages";

const MAIL_REACT_APP_TEMPLATE_ID = "template_mail_website";
const MAIL_REACT_APP_SERVICE_ID = "website_react-contact";
const MAIL_REACT_APP_PUBLIC_KEY = "apFfcvXqsGlvOjOSD";

export default function Contact() {
  const form = useRef();
  const [nomMsg, setnomMsg] = useState("");
  const [mailMsg, setmailMsg] = useState("");
  const [textMsg, settextMsg] = useState("");
  const [msgEnvoye, setMsgEnvoye] = useState("");
  const [msgError, setMsgError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (nomMsg !== "" && mailMsg !== "" && textMsg !== "") {
      // verif si email valide => si contient un @ et un .
      let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailRegex.test(mailMsg)) {
        try {
          let templateParams = {
            user_name: nomMsg,
            user_email: mailMsg,
            message: textMsg,
          };
          await emailjs
            .send(
              MAIL_REACT_APP_SERVICE_ID,
              MAIL_REACT_APP_TEMPLATE_ID,
              templateParams,
              MAIL_REACT_APP_PUBLIC_KEY
            )
            .then(
              () => {
                setnomMsg("");
                setmailMsg("");
                settextMsg("");
                setMsgEnvoye("Message envoyé. Merci");
                setMsgError("");
              },
              (error) => {
                console.log("Non envoyé", error.text);
                setMsgEnvoye("");
                setMsgError("Problème technique. Message non envoyé !");
              }
            );
        } catch (error) {
          console.error("Erreur lors de l'envoi du message :", error);
          setMsgError("Erreur lors de l'envoi du message.");
          return;
        }
      } else {
        setMsgEnvoye("");
        setMsgError("Adresse e-mail invalide !");
        return;
      }
    }
  };

  return (
    <div>
      <ContactMessages msgEnvoye={msgEnvoye} msgError={msgError} />
      <form ref={form} onSubmit={handleSubmit}>
        <div>
          <p>
            N&apos;hésitez pas à me contacter pour un projet commun dans le web.
            <br />
            Je ne manquerais pas de vous répondre.
          </p>
          <div className="my-3 flex flex-col justify-center items-center">
            <div className="relative flex flex-nowrap items-stretch w-full">
              <span
                className="flex items-center whitespace-nowrap rounded-s border border-e-0 border-solid border-neutral-200 px-3 py-[0.25rem] text-center text-base font-normal leading-[1.6] text-gray-900 dark:border-white/10 dark:text-white"
                id="addon-wrapping">
                <FontAwesomeIcon icon={faUser} className="w-4 h-4" />
              </span>
              <input
                type="text"
                className="relative m-0 block flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-surface outline-none transition duration-200 ease-in-out placeholder:text-neutral-400 focus:z-[3] focus:border-primary focus:shadow-inset focus:outline-none motion-reduce:transition-none dark:border-white/10 dark:text-white dark:placeholder:text-neutral-200 dark:autofill:shadow-autofill dark:focus:border-primary"
                placeholder="Nom"
                name="user_name"
                aria-label="Nom"
                aria-describedby="addon-wrapping"
                onChange={(e) => setnomMsg(e.target.value)}
                value={nomMsg}
                required
              />
            </div>
            <div className="relative flex flex-nowrap items-stretch w-full">
              <span
                className="flex items-center whitespace-nowrap rounded-s border border-e-0 border-solid border-neutral-200 px-3 py-[0.25rem] text-center text-base font-normal leading-[1.6] text-gray-900 dark:border-white/10 dark:text-white"
                id="addon-wrapping">
                @
              </span>
              <input
                type="email"
                className="relative m-0 block flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-gray-900 outline-none transition duration-200 ease-in-out placeholder:text-neutral-400 focus:z-[3] focus:border-blue-500 focus:shadow-sm focus:outline-none dark:border-white/10 dark:text-white dark:placeholder:text-neutral-200 dark:focus:border-blue-500"
                placeholder="E-mail"
                name="user_email"
                aria-label="E-mail"
                aria-describedby="addon-wrapping"
                onChange={(e) => setmailMsg(e.target.value)}
                value={mailMsg}
                required
              />
            </div>
            <div className="relative flex flex-nowrap items-stretch w-full">
              <span
                className="flex items-center whitespace-nowrap rounded-s border border-e-0 border-solid border-neutral-200 px-3 py-[0.25rem] text-center text-base font-normal leading-[1.6] text-gray-900 dark:border-white/10 dark:text-white"
                id="addon-wrapping">
                <FontAwesomeIcon icon={faPencil} className="w-4 h-4" />
              </span>
              <textarea
                placeholder="Message"
                name="message"
                className="h-28 relative m-0 block flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-gray-900 outline-none transition duration-200 ease-in-out placeholder:text-neutral-400 focus:z-[3] focus:border-blue-500 focus:shadow-sm focus:outline-none dark:border-white/10 dark:text-white dark:placeholder:text-neutral-200 dark:focus:border-blue-500"
                aria-label="With textarea"
                onChange={(e) => settextMsg(e.target.value)}
                value={textMsg}
                required></textarea>
            </div>
            <div className="mt-5">
              <motion.button
                whileHover="hover"
                type="submit"
                className="bg-sky-200 rounded-lg px-10 p-3 shadow hover:bg-bleuciel hover:text-white cursor-pointer flex justify-center items-center transition duration-0 hover:duration-700">
                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-6 h-6 mr-2"
                  variants={{
                    rest: { rotate: 0 },
                    hover: { rotate: 360, transition: { duration: 0.4 } },
                  }}>
                  <path d="M12 12.713l11.985-7.713h-23.97l11.985 7.713zm0 2.287l-12-7.75v12.75h24v-12.75l-12 7.75z" />
                </motion.svg>
                Envoyer
              </motion.button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
